/* eslint-disable */
/**
 * 调用服务
 */
const TaxCore = {
    version: '2.0',
    author: 'zhangc',
    /**
     * 金税服务
     */
    tax: new TaxObjectController()
}
/**
 * 金税Class
 */
function TaxObjectController() {
    let _locker = false
    const _ip = '127.0.0.1'
    const _port = '8888'
    const _InvURL = `http://${_ip}:${_port}/InvSvr`
    let _taxNr
    /* 使用usb控制器 */
    const _usbport = '7777'
    const _usbinvurl = `http://${_ip}:${_usbport}/InvSvr`


    if (TaxObjectController._unique !== undefined) {
        return TaxObjectController._unique
    }
    this.getTaxNr = function () {
        return _taxNr
    }
    this.setTaxNr = function (taxNr) {
        this._taxNr = taxNr
    }

    /**
     * 获取服务所在地址的IP
     * @return {}
     */
    this.getInvIp = function () {
        return _ip
    }

    /**
     * 设置服务Ip
     * @param {}
     *            newIp
     */
    this.setInvIp = function (newIp) {
        this._ip = newIp
    }

    /**
     * 服务端口
     * @return {}
     */
    this.getPort = function () {
        return _port
    }

    /**
     * 设置服务端口
     * @param {}
     *            newPort
     */
    this.setPort = function (newPort) {
        this._port = newPort
    }

    /**
     * 获取下张发票
     * @param {}
     *            InfoKind 发票种类
     * @param {}
     *            callback
     * @param {}
     *            sellerTaxCode  销方税号
     * @param {}
     *            machineNo  开票机号
     */
    this.invInfo = function (InfoKind, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            InfoKind
        }
        __tax_requestData(InvRequest.InvInfo, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 开票
     * @param {}
     *            invoice InvoiceUtils.js中的Invoice对象
     * @param {}
     *            callback
     * @param {}
     *            sellerTaxCode  销方税号
     * @param {}
     *            machineNo  开票机号
     */
    this.inv = function (infoKind, invoice, callback, sellerTaxCode, machineNo, kpfs) {
        if (invoice.CheckEWM == 2) {
            if (infoKind != '12') {
                __tax_requestData(InvRequest.Invoice, invoice, callback, sellerTaxCode, machineNo, kpfs)
            }
            if (infoKind == '12') {
                __tax_requestData(InvRequest.InvoiceJDCP, invoice, callback, sellerTaxCode, machineNo, kpfs)
            }
        } else {
            if (infoKind == '0' || infoKind == '2') {
                console.log(invoice)
            }
            if (infoKind != '12') {
                __tax_requestData(InvRequest.Invoice, invoice, callback, sellerTaxCode, machineNo, kpfs)
            }
            if (infoKind == '11') {
                __tax_requestData(InvRequest.InvoiceHWYS, invoice, callback, sellerTaxCode, machineNo, kpfs)
            }
            if (infoKind == '12') {
                __tax_requestData(InvRequest.InvoiceJDCP, invoice, callback, sellerTaxCode, machineNo, kpfs)
            }
        }
    }

    /**
     * 打印发票
     * @param {}
     *            InfoKind 发票类型
     * @param {}
     *            InfoTypeCode 发票代码
     * @param {}
     *            InfoNumber 发票号码
     * @param {}
     *            callback
     */
    this.printInv = function (InfoKind, InfoTypeCode, InfoNumber, PrintKind, ShowPrintDlg, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            InfoKind,
            InfoTypeCode,
            InfoNumber,
            PrintKind,
            ShowPrintDlg: 0,
        }
        __tax_requestData(InvRequest.InvPrint, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 打印发票清单
     * @param {}
     *            InfoKind 发票种类
     * @param {}
     *            InfoTypeCode 发票代码
     * @param {}
     *            InfoNumber 发票号码
     * @param {}
     *            callback
     */
    this.printInvList = function (InfoKind, InfoTypeCode, InfoNumber, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            InfoKind,
            InfoTypeCode,
            InfoNumber
        }
        __tax_requestData(InvRequest.InvListPrint, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 作废发票
     * @param {}
     *            InfoKind 发票种类
     * @param {}
     *            InfoTypeCode 发票代码
     * @param {}
     *            InfoNumber 发票号码
     * @param {}
     *            callback
     */
    this.cancel = function (InfoKind, InfoTypeCode, InfoNumber, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            InfoKind,
            InfoTypeCode,
            InfoNumber
        }
        __tax_requestData(InvRequest.InvCancel, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 调申报接口 获取发票信息,
     * @param {}
     *            beginMonth 月份数
     * @param {}
     *            endMonth 月份数,1,2,3,4,5....
     * @param {}
     *            callback
     */
    this.queryInvByMonth = function (fpzl, beginDate, endDate, callback, sellerTaxCode, machineNo, kpfs) {
        // BEGIN：add by wxb for [接口参数修改]
        const json = {
            fpzl,
            /* "xsdh": "",
            "gfmc": "",
            "gfsh":"",
            "kpjh":"",
            "xfmc": "",
            "xfsh": "",
            "fpdm": "",
            "fphm": "",
            "kpdh": "",
            "zfbz": "",
            "qdbz": "",
            "dybz": "",
            "bsbz": "",
            "RecNo":"", */
            BeginDate: beginDate,
            EndDate: endDate
        }
        // end
        if (fpzl == '0' || fpzl == '2') {
            __tax_requestData(InvRequest.QueryInvByMonth, json, callback, sellerTaxCode, machineNo, kpfs)
        }
        if (fpzl == '11') {
            __tax_requestData(InvRequest.InvoiceInvHWByMonth, json, callback, sellerTaxCode, machineNo, kpfs)
        }
        if (fpzl == '12') {
            __tax_requestData(InvRequest.InvoiceInvJDCPByMonth, json, callback, sellerTaxCode, machineNo, kpfs)
        }
    }

    /** *
     * 分页获取开票信息
     * add by wangxiaobo
     * 可传参数：
     * var json = {
     *           "fpzl":fpzl,
     *           "xsdh": xsdh,
     *           "gfmc": "",
     *           "gfsh":"",
     *           "kpjh":kpjh,
     *           /*"xfmc": "",
     *           "xfsh": "",
     *           "fpdm": "",
     *           "fphm": "",
     *           "kpdh": "",
     *           "zfbz": "",
     *           "qdbz": "",
     *           "dybz": "",
     *           "bsbz": "",
     *           "RecNo":"",
     *           "BeginDate": beginDate,
     *           "EndDate": endDate,
     *           "PageSize":pageSize,//分页大小：一次查询返回的最大记录数
     *           "PageIndex":pageIndex//当前页序号，第一页为1
     *   };
     */
    this.queryInvByPage = function (json, callback, sellerTaxCode, machineNo, kpfs) {
        // end
        const fpzl = json.fpzl
        if (fpzl == '0' || fpzl == '2' || fpzl == '41' || fpzl == '51' || fpzl == '52') {
            __tax_requestData(InvRequest.QueryInvByMonth, json, callback, sellerTaxCode, machineNo, kpfs)
        }
        if (fpzl == '11') {
            __tax_requestData(InvRequest.InvoiceInvHWByMonth, json, callback, sellerTaxCode, machineNo, kpfs)
        }
        if (fpzl == '12') {
            __tax_requestData(InvRequest.InvoiceInvJDCPByMonth, json, callback, sellerTaxCode, machineNo, kpfs)
        }
    }

    /**
     * 调用本地库，查询发票数据
     *
     */
    /* this.queryInvFromLocalDataBase = function(xfsh, BeginDate, EndDate, fpzl, callback, sellerTaxCode, machineNo, kpfs) {

        var queryJson = {"xsdh":"", "gfmc":"", "gfsh":"", "xfmc":"", "fpdm":"", "kpjh":"",
                        "fphm":"", "zfbz":"", "qdbz":"", "dybz":"", "bsbz":""};

        queryJson["xfsh"] = xfsh;
        queryJson["BeginDate"] = BeginDate;
        queryJson["EndDate"] = EndDate;
        queryJson["fpzl"] = fpzl;
        __tax_doRequest(InvRequest.QueryInvByMonth, queryJson, callback, sellerTaxCode, machineNo, kpfs);
        __tax_doRequest(InvRequest.StartInvServer, null, function(json) {
            if (json.retcode == 1011 || json.retcode == 'SB001') {
                // 开票服务,申报服务需要判断是否开启成功再执行具体业务.
                __tax_doRequest(InvRequest.QueryInvByMonth, queryJson, callback, sellerTaxCode, machineNo, kpfs);
            }
            else{
                callback(json);
            }
        });
    }; */

    this.queryInvFromLocalDataBase = function (queryJson, callback, sellerTaxCode, machineNo, kpfs) {
        __tax_doRequest(InvRequest.QueryInvByMonth, queryJson, callback, sellerTaxCode, machineNo, kpfs)
        /* __tax_doRequest(InvRequest.StartInvServer, null, function(json) {
            if (json.retcode == 1011 || json.retcode == 'SB001') {
                // 开票服务,申报服务需要判断是否开启成功再执行具体业务.
                __tax_doRequest(InvRequest.QueryInvByMonth, queryJson, callback, sellerTaxCode, machineNo, kpfs);
            }
            else{
                callback(json);
            }
        }); */
    }


    /**
     * 申报接口获取领用存信息 S--期初库存； B--本期领购； U--本期开具； R--误售退回； W--作废或遗失； E--期末库存；
     * @param {}
     *            callback
     */
    this.queryLYC = function (callback, sellerTaxCode, machineNo, kpfs) {
        __tax_doRequest(InvRequest.StartInvServer, null, (json) => {
            if (json.retcode == 1011 || json.retcode == 'SB001') {
                // 开票服务,申报服务需要判断是否开启成功再执行具体业务.
                __tax_doRequest(InvRequest.QueryLYC, null, callback, sellerTaxCode, machineNo, kpfs)
            } else {
                callback(json)
            }
        }, sellerTaxCode, machineNo, kpfs)
    }

    /**
     *
     * 获取单机版开票软件【数据库】中的领用存信息
     * @param {}
     *            qrq
     * @param {}
     *            zrq
     * @param {}
     *            callback
     */
    this.queryDBLYC = function (qrq, zrq, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            qrq,
            zrq
        }
        __tax_requestData(InvRequest.QueryDBLYC, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 获取单机版开票软件【数据库】中的发票信息
     * @param {}
     *            qrq
     * @param {}
     *            zrq
     * @param {}
     *            zfkd
     * @param {}
     *            callback
     */
    this.queryDBInvs = function (qrq, zrq, zfkd, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            qrq,
            zrq,
            zfkd
        }
        __tax_requestData(InvRequest.QueryDBInvs, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 获取单机版开票软件【数据库】中的发票商品信息
     * @param {}
     *            qrq
     * @param {}
     *            zrq
     * @param {}
     *            zfkd
     * @param {}
     *            callback
     */
    this.queryDBDetail = function (qrq, zrq, zfkd, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            qrq,
            zrq,
            zfkd
        }
        // do
        __tax_requestData(InvRequest.QueryDBInvDetail, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 获取单机版开票软件【数据库】中的查询清单
     * @param {}
     *            qrq
     * @param {}
     *            zrq
     * @param {}
     *            zfkd
     * @param {}
     *            callback
     */
    this.queryDBList = function (qrq, zrq, zfkd, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            qrq,
            zrq,
            zfkd
        }
        // do
        __tax_requestData(InvRequest.QueryDBInvList, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 启动开票服务
     * @param {callback}
     */
    this.startInvSvr = function (callback, sellerTaxCode, machineNo, kpfs) {
        __tax_doRequest(InvRequest.StartInvServer, null, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 启动查询服务
     * @param {callback}
     */
    this.startQrySvr = function (callback, sellerTaxCode, machineNo, kpfs) {
        __tax_doRequest(InvRequest.StartQueryServer, null, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 启动抄报服务（已取消）
     * @param {callback}
     */
    this.chaoBao = function (callback) {
        __tax_doRequest(InvRequest.ChaoBao, null, callback)
    }

    /**
     * 发票上传
     * @param {}
     *            InfoTypeCode 发票代码
     * @param {}
     *            InfoNumber 发票号码
     * @param {}
     *            callback
     */
    this.InvUploadSub = function (InfoTypeCode, InfoNumber, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            fpdm: InfoTypeCode,
            fphm: InfoNumber
        }
        __tax_requestData(InvRequest.InvUpload, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 发票上传状态更新
     * @param {}
     *            callback
     */
    this.InvStatusUpdateSub = function (callback, sellerTaxCode, machineNo, kpfs) {
        __tax_requestData(InvRequest.InvStatusUpdate, null, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 单张发票信息查询
     * @param {}
     *            InfoKind 发票类型
     * @param {}
     *            InfoTypeCode 发票代码
     * @param {}
     *            InfoNumber 发票号码
     * @param {}
     *            callback
     */
    this.QryInvInfoDetail = function (invoice, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            fpzl: invoice.invType,
            gfmc: invoice.custName,
            gfsh: invoice.custCreditCode,
            xsdbh: invoice.kplsh,
            hjbhsje: invoice.totalAmt
        }
        __tax_requestData(InvRequest.QryInvInfo, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    this.VehicleInvInfoDetail = function (invoice, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            fpzl: '12',
            gfmc: invoice.custName,
            gfsh: invoice.custCreditCode,
            xsdh: invoice.kplsh,
            hjbhsje: invoice.totalAmt
        }
        __tax_requestData(InvRequest.InvoiceInvJDCPByMonth, json, callback, sellerTaxCode, machineNo, kpfs)
    }
    /**
     * 批量发票信息查询
     * @param {}
     *            fplist[] 发票种类,代码,号码列表
     * @param {}
     *            callback
     */
    this.QryInvInfoDetailList = function (fplist, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            fplist
        }
        __tax_requestData(InvRequest.QryInvInfoList, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 发票批量报送; 金税设备状态查询; 红票上传下载
     * @param {}
     *            bwInput 输入报文参数
     * @param {}
     *            callback
     */
    this.InvBatchUploadSub = function (bwInput, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            param: bwInput
        }
        __tax_requestData(InvRequest.InvBatchUpload, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 发票批量报送结果下载
     * @param {}
     *            bwInput 输入报文参数
     * @param {}
     *            callback
     */
    this.InvBatchUpdateSub = function (bwInput, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            param: bwInput
        }
        __tax_requestData(InvRequest.InvBatchUpdate, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 开票(货运发票)
     * @param {}
     *            invoice InvoiceUtils.js中的Invoice对象
     * @param {}
     *            callback
     */
    this.invHWYS = function (invoice, callback) {
        __tax_requestData(InvRequest.InvoiceHWYS, invoice, callback)
    }

    /**
     * 开票(机动车发票)
     * @param {}
     *            invoice InvoiceUtils.js中的Invoice对象
     * @param {}
     *            callback
     */
    this.invJDCP = function (invoice, callback) {
        __tax_requestData(InvRequest.InvoiceJDCP, invoice, callback)
    }

    /**
     * 查询金税盘设备信息
     * @param {}
     *            bwInput 输入报文参数
     * @param {}
     *            callback
     */
    this.InvGetInvoiceInfoData = function (bwInput, callback, sellerTaxCode, machineNo, kpfs) {
        const json = {
            SIDParam: bwInput
        }
        __tax_requestData(InvRequest.InvoiceInfoData, json, callback, sellerTaxCode, machineNo, kpfs)
    }

    /**
     * 取开票软件中商品分类编码信息
     * @param {}
     *            callback
     */
    this.InvGetFlbmInfoData = function (callback, sellerTaxCode, machineNo, kpfs) {
        __tax_requestData(InvRequest.FlbmInfoData, null, callback, sellerTaxCode, machineNo, kpfs)
    }

    var InvRequest = {
        /**
         * 获取发票信息
         */
        InvInfo: 0,
        /**
         * 发票开具
         */
        Invoice: 1,
        /**
         * 发票打印
         */
        InvPrint: 2,
        /**
         * 清单打印
         */
        InvListPrint: 3,
        /**
         * 发票作废
         */
        InvCancel: 4,
        /**
         * 查询整月发票
         */
        QueryInvByMonth: 5,
        /**
         * 查询领用存信息
         */
        QueryLYC: 6,
        /**
         * 查询数据库中发票领用存信息
         */
        QueryDBLYC: 8,
        /**
         * 查询发票头
         */
        QueryDBInvs: 9,
        /**
         * 发票明细
         */
        QueryDBInvDetail: 10,
        /**
         * 发票清单
         */
        QueryDBInvList: 11,
        /**
         * 开启开票服务
         */
        StartInvServer: 12,
        /**
         * 开启查询服务
         */
        StartQueryServer: 13,
        /**
         * 抄报
         */
        ChaoBao: 14,
        /**
         * 发票上传
         */
        InvUpload: 15,
        /**
         * 发票状态更新
         */
        InvStatusUpdate: 16,
        /**
         * 单张发票信息查询
         */
        QryInvInfo: 17,
        /**
         * 批量发票信息查询
         */
        QryInvInfoList: 18,
        /**
         * 发票批量报送结果下
         */
        InvBatchUpdate: 19,
        /**
         * 载发票批量报送; 金税设备状态查询; 红票上传下载
         */
        InvBatchUpload: 20,
        /**
         * 货运发票填开
         */
        InvoiceHWYS: 21,
        /**
         * 机动车发票填开
         */
        InvoiceJDCP: 22,
        /**
         * 查询货运发票信息
         */
        InvoiceInvHWByMonth: 23,
        /**
         * 查询机动车发票信息
         */
        InvoiceInvJDCPByMonth: 24,
        /**
         * 查询金税盘设备信息
         */
        InvoiceInfoData: 25,
        /**
         * 读取开票软件中商品分类编码信息
         */
        FlbmInfoData: 28

    }

    /**
     * 请求底层服务,增加了检查服务状态
     *
     * @param {}
     *            SID
     * @param {}
     *            JsonString
     * @param {}
     *            callback
     */
    function __tax_requestData(SID, JsonString, callback, sellerTaxCode, machineNo, kpfs) {
        if (checkSoapBeforeTaxCore()) return
        let funcName // 调用方法名称
        Object.keys(InvRequest).forEach((k) => {
            if (InvRequest[k] == SID) {
                funcName = k
            }
        })


        const serverType = SID
        let realUrl = REAL_URL.replace('8888', localStorage.soapPort)

        __printDebugLog(`${'*****【' + '向服务地址:'}${realUrl}发送请求:${funcName}】****`)
        /* var serverType;// 请求开票服务还是查询服务
        if (InvRequest.QueryDBInvDetail == SID
                || InvRequest.QueryDBInvList == SID
                || InvRequest.QueryDBInvs == SID
                || InvRequest.QueryDBLYC == SID
                || InvRequest.QueryInvByMonth == SID
                || InvRequest.InvoiceInvHWByMonth == SID
                || InvRequest.InvoiceInvJDCPByMonth == SID
                || InvRequest.QueryLYC == SID) {
            serverType = InvRequest.StartQueryServer;
        } else if (SID == InvRequest.ChaoBao) {
            serverType = InvRequest.ChaoBao;
        } else {
            serverType = InvRequest.StartInvServer;
        } */
        $.get(realUrl).done(() => {
            __tax_doRequest(SID, JsonString, callback, sellerTaxCode, machineNo, kpfs)
        }).fail(() => { //fail add by fwc
            callback(null);
        })
        /* if(SID != 25){
            // 先检查服务是否开启,再调用具体业务功能.
            __tax_doRequest(serverType, null, function(json) {
                if (json.retcode == 1011 || json.retcode == 'SB001') {
                    // 开票服务,申报服务需要判断是否开启成功再执行具体业务.
                    __tax_doRequest(SID, JsonString, callback, sellerTaxCode, machineNo,kpfs);
                } else if (json.retcode == 'WCCB001') {
                    // 抄报特殊, 不需要启动服务.直接运行
                    __printDebugLog($.parseJSON(json));
                    callback(json);
                } else {
                    __printDebugLog("服务启动失败.", "e");
                    callback(json);
                }
            }, sellerTaxCode, machineNo,kpfs);
        } else {
            __tax_doRequest(SID, JsonString, callback, sellerTaxCode, machineNo,kpfs);
        } */
    }

    /**
     * 向服务发送请求
     *
     * @param {}
     *            SID
     * @param {}
     *            JsonString
     * @param {}
     *            callback
     */
    function __tax_doRequest(SID, JsonString, callback, sellerTaxCode, machineNo, kpfs) {
        if (checkSoapBeforeTaxCore()) return
        __printDebugLog(`-->请求参数:(SID=${SID})${JsonString}`, 'i')
        let realUrl = REAL_URL.replace('8888', localStorage.soapPort)
        let _URL = ''
        if (kpfs == 0) {
            _URL = realUrl
        } else {
            _URL = _usbinvurl
        }
        // Begin:add by wxb for [红字信息表接口模拟] on 2018-04-08
        if (SID == 20) {
            _URL = getMockAddr(_URL)
        }
        // end

        // 返回json对象
        let returnJson = {
            SID,
            retcode: -1,
            retmsg: '',
            value: '{"retcode": -1}',
        }

        if (kpfs != 0) {
            /* if(null==sellerTaxCode || "".equals(sellerTaxCode)){
                returnJson.retmsg = "销方税号未传入";
                callback(returnJson);
                return;
            } */
        }

        if (JsonString != null && JsonString != '') {
            JsonString = JSON.stringify(JsonString)
            JsonString = Base64CodeN(JsonString, 'encode', kpfs)
            JsonString = JsonString.replace(new RegExp('[+]', 'gm'), '%2B')

            __printDebugLog(`-->请求参数（加密后）:${JsonString}`, 'i')
        }
        const textparam = {}
        textparam.SID = SID
        // if (SID == 2 || SID == 3) textparam.CODE = UNICODE
        if (JsonString != null) {
            JsonString = $.parseJSON(JsonString)
            textparam.SIDParam = JsonString.value
        }
        // var textparam = "SID=" + SID + "&SIDParam=" + JsonString;
        if (kpfs != 0) {
            textparam.taxcode = sellerTaxCode
            textparam.machineNO = machineNo
            textparam.key = JsonString.key
            textparam._ = JsonString._
        }

        try {
            // if(SID == 12 || SID == 13 || SID == 14 || SID == 25){//切换开票服务，查询服务，远程抄报服务
            if (SID == 13 || SID == 14 || SID == 25) { // 切换开票服务，查询服务，远程抄报服务
                // JSONP跨域提交 目前无需跨域
                $.ajax({
                    url: _URL,
                    /* data : {
                        'SID' : SID,
                        'SIDPARAM' : JsonString
                    }, */
                    type: 'post',
                    data: textparam,
                    scriptCharset: 'UTF-8',
                    dataType: 'json',
                    timeout: 30000,
                    /**
                     * 做发送请求前的数据校验
                     * @return {Boolean} 返回false校验不通过不发送请求.
                     */
                    beforeSend(xhr) {
                        // 校验回调函数
                        if (!callback) {
                            returnJson.retmsg = '回调函数callback参数未传入!' // 设置返回错误信息
                            returnJson.value = '{"retcode": -1, "retmsg": "回调函数callback参数未传入!"}'
                            __printDebugLog(returnJson.retmsg, 'w')
                            return false
                        }
                        // 校验锁
                        if (_locker) {
                            returnJson.retmsg = '存在请求未处理,请稍后重试!' // 设置返回错误信息
                            returnJson.value = '{"retcode": -1, "retmsg": "存在请求未处理,请稍后重试!"}'
                            __printDebugLog(returnJson.retmsg, 'w')
                            callback(returnJson)
                            return false // 中断请求
                        }
                        // 正式发送请求
                        _locker = true // 加锁,表示无当前正在执行请求任务,其他请求不接受处理
                        return true
                    },
                    /**
                     * 调用成功
                     * @param {}
                     *            json对象 返回参数
                     */
                    success(json) {
                        __printDebugLog(`返回报文-->${$.parseJSON(json)}`, 'i')
                        let ENCMSG = json.ENCMSG

                        ENCMSG = ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                        // var DECMSG = Base64CodeN(ENCMSG, "decode64", kpfs);
                        let DECMSG = Base64CodeN(ENCMSG, 'decode', kpfs)
                        __printDebugLog(`解密后返回报文-->${DECMSG}`, 'i')

                        DECMSG = DECMSG.replace(/\\\\r|\\\\t|\\\\n|\\r|\\t|\\n|\r|\t|\n/g, ' ')
                        const jsonObj = JSON.parse(DECMSG)

                        // 服务返回空,服务异常
                        if (!jsonObj) {
                            returnJson.retmsg = '服务无响应...'
                            returnJson.value = '{"retcode": -1, "retmsg": "服务无响应..."}'
                        } else {
                            returnJson = jsonObj
                        }
                        _locker = false // 打开锁,表示无当前无其他任务
                    },
                    /**
                     * 请求错误
                     */
                    error(XMLHttpRequest, textStatus, errorThrown) {
                        AjaxErrorManage(XMLHttpRequest, textStatus, errorThrown, '1')
                        returnJson.retmsg = '尝试连接服务失败，请确认控制台是否已打开！'
                        returnJson.value = '{"retcode": -1, "retmsg": "尝试连接服务失败，请确认控制台是否已打开！"}'
                        _locker = false // 打开锁,表示无当前无其他任务,可接受后面请求的处理
                    },
                    /**
                     * ajax 完成,统一调用回调函数
                     *
                     * @param {}
                     *            XMLHttpRequest
                     * @param {}
                     *            status
                     */
                    complete(XMLHttpRequest, status) {
                        if (status == 'timeout') { // 超时
                            returnJson.retmsg = '请求超时!'
                            returnJson.value = '{"retcode": -1, "retmsg": "请求超时!"}'
                            __printDebugLog(returnJson.retmsg, 'e')
                            callback(returnJson)
                        } else if (returnJson.retcode == -1) { // 错误
                            __printDebugLog(returnJson.retmsg, 'e')
                            callback(returnJson)
                        } else { // 正常
                            callback(returnJson)
                        }
                    }
                })
            } else {
                if (_locker) {
                    returnJson.retmsg = '存在请求未处理,请稍后重试!' // 设置返回错误信息
                    returnJson.value = '{"retcode": -1, "retmsg": "存在请求未处理,请稍后重试!"}'
                    __printDebugLog(returnJson.retmsg, 'w')
                    callback(returnJson)
                    return false // 中断请求
                }
                _locker = true // 加锁,表示无当前正在执行请求任务,其他请求不接受处理

                let v_timeout = 30000
                if (SID == 5) {
                    v_timeout = 120000
                }
                //add by fwc---->
                if (SID == 1 || SID == 17) {
                    v_timeout = 120000
                    returnJson.retmsg = '发票前端开具超时，已转至后台处理，请稍后再试' // 设置返回错误信息
                    returnJson.value = '{"retcode": -1, "retmsg": "发票前端开具超时，已转至后台处理，请稍后再试"}'
                } else {
                    returnJson.retmsg = '金税盘服务调用失败' // 设置返回错误信息
                    returnJson.value = '{"retcode": -1, "retmsg": "金税盘服务调用失败"}'
                }
                //add by fwc <----
                $.ajax({
                    url: _URL,
                    /* data : {
                        "SID" : SID,
                        "SIDPARAM" : JsonString
                    }, */
                    type: 'post',
                    data: textparam,
                    scriptCharset: 'UTF-8',
                    dataType: 'json',
                    timeout: v_timeout,
                    success(json) {
                        // __printDebugLog("返回报文-->" + $.parseJSON(json), 'i');
                        let ENCMSG = json.ENCMSG


                        ENCMSG = ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                        // var DECMSG = Base64CodeN(ENCMSG, "decode64", kpfs);
                        if (SID == 5 || SID == 24) {
                            let DECMSG = Base64CodeN(ENCMSG, 'decode', kpfs, 1)
                            __printDebugLog(`解密后返回报文-->${DECMSG}`, 'i')
                            $.post({
                                url: `${window.location.origin}/etcloud/etcloud-sys/common/common/getJSONObject`,
                                dataType: 'json',
                                data: JSON.stringify({
                                    data: DECMSG
                                }),
                                contentType: 'application/json; charset=utf-8',
                                success(res) {
                                    const jsonObj = res.value
                                    if (!jsonObj) {
                                        returnJson.retmsg = '服务无响应...'
                                        returnJson.value = '{"retcode": -1, "retmsg": "服务无响应..."}'
                                    } else {
                                        returnJson = jsonObj
                                    }
                                    _locker = false
                                    callback(returnJson)
                                }
                            })
                        } else {
                            let DECMSG = Base64CodeN(ENCMSG, 'decode', kpfs)
                            __printDebugLog(`解密后返回报文-->${DECMSG}`, 'i')

                            DECMSG = DECMSG.replace(/\\\\r|\\\\t|\\\\n|\\r|\\t|\\n|\r|\t|\n/g, ' ')

                            const jsonObj = JSON.parse(DECMSG)
                            // 服务返回空,服务异常
                            if (!jsonObj) {
                                returnJson.retmsg = '服务无响应...'
                                returnJson.value = '{"retcode": -1, "retmsg": "服务无响应..."}'
                            } else {
                                returnJson = jsonObj
                            }
                            _locker = false
                            callback(returnJson)
                        }
                    },
                    error() {
                        _locker = false
                        callback(returnJson)
                    }
                })
            }
        } catch (e) {
            _locker = false // 打开锁,表示无当前无其他任务
            returnJson.retmsg = `控件正在加载，请稍后再试。(${e.message})`
            returnJson.value = `{"retcode": -1, "retmsg": "控件正在加载，请稍后再试。(${e.message})"}`
            callback(returnJson)
        }
    }

    TaxObjectController._unique = this
}


/** ***********************************************共用方法*************************************************** */

/**
 * 控制台打印
 *
 * @param json
 *            obj 打印输出内容
 * @param String
 *            level e-错误,i-信息,w-警告,默认日志
 */
function __printDebugLog(objInfo, level) {
    if (window.console) {
        if (level == 'i') {
            window.console.info(objInfo)
        } else if (level == 'e') {
            window.console.error(`错误信息:${objInfo}`)
        } else if (level == 'w') {
            window.console.error(`警告信息:${objInfo}`)
        } else {
            window.console.log(objInfo)
        }
    }
}

/**
 * base64加密解密函数
 *
 * @param input
 *            传入加密，解密前字符
 * @param codeType
 *            加密，解密 标识  encode64:加密; decode64:解密;
 */
function Base64CodeN(input, codeType, kpfs, isObj) {
    if (isObj) {
        let response = {}
        $.ajax({
            type: 'POST',
            url: `${host.etcloudOvat}ovatInvoiceWait/base64DeCode`,
            async: false,
            contentType: 'application/json; charset=utf-8',
            beforeSend(request) {
                const token = localStorage.getItem('id_token')
                if (token) {
                    request.setRequestHeader('accessToken', token)
                }
            },
            /* complete:function(XMLHttpRequest){
                if(XMLHttpRequest != null &&
                XMLHttpRequest.responseText.indexOf("<script>alert('登录超时,请重新登录!');self.top.location.href =") != -1 &&
                XMLHttpRequest.responseText.indexOf("logOff.action") != -1){
    
                    __printDebugLog("-->请求异常:(" + XMLHttpRequest.readyState + ") 请求登录已超时,跳转到登陆页面.", "w");
    
                    alert('登录已超时,请重新登录!');
                    self.top.location.href = GlobalUrlContextPath + "\logOff.action";
                    return;
                }
            }, */
            data: JSON.stringify({
                invData: input,
                codeType,
                kpfs
            }),
            success(res) {
                response = res.value
            }
        })
        return response
    } else {
        const result = $.ajax({
            type: 'POST',
            url: `${host.etcloudOvat}ovatInvoiceWait/base64DeCode`,
            async: false,
            contentType: 'application/json; charset=utf-8',
            beforeSend(request) {
                const token = localStorage.getItem('id_token')
                if (token) {
                    request.setRequestHeader('accessToken', token)
                }
            },
            /* complete:function(XMLHttpRequest){
                if(XMLHttpRequest != null &&
                XMLHttpRequest.responseText.indexOf("<script>alert('登录超时,请重新登录!');self.top.location.href =") != -1 &&
                XMLHttpRequest.responseText.indexOf("logOff.action") != -1){
    
                    __printDebugLog("-->请求异常:(" + XMLHttpRequest.readyState + ") 请求登录已超时,跳转到登陆页面.", "w");
    
                    alert('登录已超时,请重新登录!');
                    self.top.location.href = GlobalUrlContextPath + "\logOff.action";
                    return;
                }
            }, */
            data: JSON.stringify({
                invData: input,
                codeType,
                kpfs
            })
        }).responseText

        if (!result) {
            return ''
        }
        return result
    }
    // return eval(result);
}

/**
 * 特殊数据处理
 *
 * @param objInfo
 *            接口返回数据
 * @param SID
 *            接口SID号
 */
function tsRetJsonCon(objInfo, SID) {
    if (SID == 0) {
        objInfo.Kpfwqh = parseInt(objInfo.Kpfwqh, 10)
        objInfo.MachineNo = parseInt(objInfo.MachineNo, 10)
        return objInfo
    }
    return objInfo
}
window.TaxCore = TaxCore
/** ***********************************************共用方法*************************************************** */
// begin: add by wxb for  [开票软件接口模拟 ]  地址切换
/** *
 * 如果是测试环境会返回 模拟地址，不是的化会返回真实地址
 * 测试地址为 192.168.51.38 , 129.168.51.13
 */
function getMockAddr() {
    let realUrl = MOCK_URL.replace('8888', localStorage.soapPort)
    return realUrl
}
// end


// WEBPACK FOOTER //
// ./vendor/tax/TAX_CORE.js